export type CreateEventAccess = 'loading' | 'allowed' | 'login' | 'dashboard';

export const resolveCreateEventAccess = (
  isLoading: boolean,
  isAuthenticated: boolean,
  isMaster: boolean,
): CreateEventAccess => {
  if (isLoading) return 'loading';
  if (!isAuthenticated) return 'login';
  return isMaster ? 'allowed' : 'dashboard';
};
